const MAPPED_ERRORS = {
  UNAUTHENTICATED: 'Você não possui permissão para executar essa ação'
}

export const mapErrorToMessage = (errorCode: string, customMessage?: string) => {
  return MAPPED_ERRORS[errorCode as keyof typeof MAPPED_ERRORS] || (customMessage ?? '')
}
